import React from 'react';
import whatsappIcon from '/static/icons/wsp-circle.webp'; // Import the WhatsApp icon

const FloatingWhatsAppButton = () => {
  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '60px',
    height: '60px',
    zIndex: 1000,
    borderRadius: '50%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s',
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
  };

  return (
    <a
      href="https://wa.me/5491138181906?text=Hola%20Felipe.%20Tengo%20inter%C3%A9s%20en%20conocer%20m%C3%A1s%20sobre%20Burbuxa.%20Trabajo%20en%20NombreDeMarca"
      target="_blank"
      rel="noopener noreferrer"
      style={buttonStyle}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <img src={whatsappIcon} alt="WhatsApp" style={imgStyle} />
    </a>
  );
};

export default FloatingWhatsAppButton;
